// extracted by mini-css-extract-plugin
export var legendIndicator = "_ev-1";
export var legendRight = "_ev-0";